/**
 * BI — BASIC / PRO ТҮВШНИЙ АНГИЛАЛ (docs/46 §9 Ү7, §11 D1; docs/31 §4t). НЭГ газар — API-ийн хаалга ба админы
 * `MetricDef`-ийн түвшин ХОЁУЛАА ЭНЭ файлаас.
 *
 * ! 🔴 ҮНЭН ХААЛГА СЕРВЕРТ (D7-4). Админ Pro хавтанг «Pro эрх шаардлагатай» картаар түгжих нь зөвхөн UX — хамгаалалт нь
 * ! `BiTierInterceptor` (API): `bi.pro:show`-гүй хүнд мөнгөн талбар `null` + `redacted` тэмдэг (0 ХЭЗЭЭ Ч БИШ), хүн/багийн
 * ! хэмжээс, төлөвлөгөө, санхүү 403 `BI_PRO_REQUIRED`. Кэш нь ТҮҮХИЙ мөр хадгалдаг — буулгалт хүсэлт БҮРД, хуулбараар
 * ! (`redactBiPayload` эх объектыг ХЭЗЭЭ Ч өөрчлөхгүй: single-flight/кэшийн объект Pro хэрэглэгчтэй хуваалцагддаг).
 *
 * ! ЭЗЭМШИГЧИЙН ШИЙДВЭР D7-1 (2026-09-26) — Pro-д л:
 * !   (a) БҮХ мөнгөн дүн (₮: орлого, дүн, дундаж падаан, буцаалтын дүн, захиалгын дүн, төлбөр, авлага, лимит, өр …);
 * !   (b) хүн / багийн гүйцэтгэл (борлуулалтын баг = 1С хэрэглэгч `salesManager`, харилцагчийн менежер `manager`, борлуулагч)
 * !       — задаргааны мөр нь ажилтан/баг, ЭСВЭЛ тэдгээрээр шүүх;
 * !   (c) төлөвлөгөө-гүйцэтгэл (бүх хэсэг);
 * !   (d) санхүүгийн домэйн бүхэлдээ.
 * ! Бусад нь Basic: тоо, тоо хэмжээ (баримт, захиалга, харилцагч, ширхэг, багц, гүйлт, буцаалтын ТОО, ажилтан, ирц …).
 *
 * ! Ү8 (docs/31 §4u, D8-1…D8-12): ГУРАВ ДАХЬ ТҮВШИН «Менежер» (`bi.manager:show`) — мөнгийг ЗӨВХӨН хэрэглэгчид
 * ! хуваарилагдсан БОРЛУУЛАЛТЫН СУВАГ(ууд)-ын хүрээнд (борлуулалт, санхүү). Түвшин = ХЭМЖИГДЭХҮҮН (мөнгө эсэх), суваг = ХҮРЭЭ
 * ! (мөр; `ErpScope.salesChannels`, түвшнээс үл хамааран). Түвшинг СЕРВЕР эрх + хүрээнээс гаргана (`resolveBiAccess`) —
 * ! `?tier=` өгөгдлийн параметр БАЙХГҮЙ (D8-3). Менежерийн мөнгө FAIL-CLOSED (D8-4): бодлого `manager: 'money'` БА хариу
 * ! `applied.salesChannel` ⊆ хэрэглэгчийн суваг (хоосон биш) үед л — эс бөгөөс буулгалт/403 (API-ийн post-assert).
 * ! Ү7-ийн нэрс (`biRouteDecision(…, hasPro)`, `biProRequiredBody`, `biExportTierProblem(…, hasPro)`, `biRequestTier`,
 * ! `biStaticTier`) ХЭВЭЭР — Basic/Pro хариу БАЙТ-АА ТЭНЦҮҮ (D8-3). Шинэ нэрс: `biAccessDecision`, `biTierRequiredBody`,
 * ! `biExportAccessProblem`, `biRequestMinTier`, `biStaticMinTier`.
 *
 * ! Шинэ BI цэг нэмэхэд: `BI_ROUTE_TIERS`-д мөр нэмж (`manager` ЗААВАЛ), контроллерын handler-т `@BiRoute(<түлхүүр>)` тавь — API-ийн spec
 * ! (`bi-tier/*.spec.ts`) BI контроллерын handler БҮР ангилагдсан, зам/арга таарч буйг шалгана. Админы spec
 * ! (`tiers/*.spec.ts`) `MetricDef` БҮРИЙН түвшин = энэ хүснэгтээр тооцсон түвшин гэдгийг шалгана.
 */

import { BI_PROMOS_ROUTE_POLICY } from './bi-drill.js'
import { BI_BOARD_TIERS } from './bi.js'
import type { BiBoardTier, BiDomainKey, BiTier } from './bi.js'

/* ─────────────────────────── Эрх ба алдааны код ─────────────────────────── */

/** Pro түвшний эрх (BI манифест). `admin`/`super-admin` seed-ээр авна; бизнесийн «Удирдлага» дүрд /settings/roles-оос. */
export const BI_PRO_PERMISSION = 'bi.pro:show' as const

/** 403-ийн `code` — админ үүгээр «эрхгүй» (эх жагсаалтын эрх) ба «Pro эрх шаардлагатай»-г ЯЛГАНА. */
export const BI_PRO_REQUIRED_CODE = 'BI_PRO_REQUIRED' as const

/**
 * Ү8 — МЕНЕЖЕР ТҮВШНИЙ ЭРХ (BI манифест). Мөнгө ЗӨВХӨН өөрийн борлуулалтын сувгийн хүрээнд (D8-2/D8-4). `admin`/`super-admin`
 * seed-ээр; бизнест `sales-manager` дүр (seed). PIN-ийн жагсаалтад ОРОХГҮЙ (мөнгө).
 */
export const BI_MANAGER_PERMISSION = 'bi.manager:show' as const

/**
 * Ү8 — 403-ийн `code`: Менежер эрхтэй ч сувгийн хүрээгүй (`managerBlocked`) хэрэглэгч Менежерийн мөнгөн цэг рүү хандсан.
 * `reason: 'channel'`, `detail: 'no-employee' | 'no-channel'`. Админ «Суваг тохируулаагүй» мэдэгдэл гаргана.
 */
export const BI_MANAGER_CHANNEL_REQUIRED_CODE = 'BI_MANAGER_CHANNEL_REQUIRED' as const

export const BI_TIER_REQUIRED_CODES = [BI_PRO_REQUIRED_CODE, BI_MANAGER_CHANNEL_REQUIRED_CODE] as const

export type BiTierRequiredCode = (typeof BI_TIER_REQUIRED_CODES)[number]

/** Ү8 — Менежерийн мөнгө нээгдэх домэйн (D8-2). Бусад домэйнд Менежер = Basic. */
export const BI_MANAGER_DOMAINS: readonly BiDomainKey[] = ['sales', 'finance']

/**
 * ЯАГААД PRO ВЭ:
 *   `domain`    — домэйн бүхэлдээ Pro (санхүү, D7-1 d);
 *   `endpoint`  — цэг бүхэлдээ Pro (төлөвлөгөө-гүйцэтгэл, D7-1 c);
 *   `dimension` — задаргааны хэмжээс нь ажилтан/баг (`by=salesManager|manager`, D7-1 b);
 *   `measure`   — задаргааны хэмжигдэхүүн мөнгө (`metric=amountVat`, анхдагч нь ч мөн, D7-1 a);
 *   `filter`    — ажилтан/багаар шүүсэн (`salesManager`, `manager` facet, D7-1 b);
 *   `board`     — Pro самбар (`?tier=pro`) унших/хадгалах/нийтлэх;
 *   `export`    — Excel-ийн ачаанд мөнгөн (`mnt`) багана/гарчиг эсвэл Pro домэйн.
 */
export const BI_PRO_REASONS = ['domain', 'endpoint', 'dimension', 'measure', 'filter', 'board', 'export'] as const

export type BiProReason = (typeof BI_PRO_REASONS)[number]

/**
 * Ү8 — 403/буулгалтын ӨРГӨТГӨСӨН шалтгаан (нэмэлт; Ү7-ийн утгууд ХЭВЭЭР):
 *   `channel`    — Менежер эрхтэй ч сувгийн хүрээгүй (`BI_MANAGER_CHANNEL_REQUIRED`, `detail: no-employee|no-channel`), эсвэл
 *                  API-ийн post-assert хариуны `applied.salesChannel`-ийг баталж чадаагүй (буулгалтын `reason`);
 *   `unscopable` — цэгийг сувгаар огтлох боломжгүй (төлөвлөгөө, D8-6) — Менежерт 403, `unlockTiers: ['pro']`.
 *
 * ! OpenAPI-ийн `BiProRequiredResponse.reason` enum нь Ү7-ийн `BI_PRO_REASONS` хэвээр — API-SCOPE-TIER нь хаалгаа шинэ
 * ! биед шилжүүлэхдээ enum-ийг `BI_TIER_REASONS` болгож, `openapi:export`-оор JSON + docs/48-ийг шинэчилнэ.
 */
export const BI_TIER_REASONS = [...BI_PRO_REASONS, 'channel', 'unscopable'] as const

export type BiTierReason = (typeof BI_TIER_REASONS)[number]

/** Ү8 — түгжээг НЭЭХ түвшин (хамгийн багаас дээш эрэмбэлсэн). `basic` хэзээ ч нээгч биш. */
export type BiUnlockTier = Exclude<BiTier, 'basic'>

/** Ү8 — Менежер эрхтэй ч мөнгө нээгдэхгүй шалтгаан (D8-3): ажилтантай холбоогүй / сувгийн хуваарилалтгүй. */
export const BI_MANAGER_BLOCKED = ['no-employee', 'no-channel'] as const

export type BiManagerBlocked = (typeof BI_MANAGER_BLOCKED)[number]

/** 403-ийн бие — `ForbiddenException(body)`. `detail` = хаасан параметр/талбар (`by=salesManager`), эсвэл `null`. */
export type BiProRequiredBody = {
  statusCode: 403
  error: 'Forbidden'
  code: typeof BI_PRO_REQUIRED_CODE
  reason: BiProReason
  message: string
  detail: string | null
}

export const biProRequiredBody = (reason: BiProReason, detail: string | null = null): BiProRequiredBody => ({
  statusCode: 403,
  error: 'Forbidden',
  code: BI_PRO_REQUIRED_CODE,
  reason,
  message: 'Pro эрх шаардлагатай (bi.pro:show)',
  detail
})

/** Хэрэглэгч Pro эрхтэй юу — `super-admin` seed-ээр БҮХ эрхийг (`*`) жагсаалтаар авдаг тул энгийн шалгалт хангалттай. */
export const hasBiPro = (permissions: readonly string[] | null | undefined): boolean =>
  Boolean(permissions?.includes(BI_PRO_PERMISSION))

/** Ү8 — Менежер эрхтэй юу (сувгийн хүрээг ҮЛ ТООЦНО — хандалт нь `resolveBiAccess`). */
export const hasBiManager = (permissions: readonly string[] | null | undefined): boolean =>
  Boolean(permissions?.includes(BI_MANAGER_PERMISSION))

/**
 * Ү8 — 403-ийн ӨРГӨТГӨСӨН бие (нэмэлт): `code` ∈ `BI_PRO_REQUIRED | BI_MANAGER_CHANNEL_REQUIRED`, `reason` ∈ `BI_TIER_REASONS`,
 * `unlockTiers` — түгжээг нээх түвшин (`['manager','pro']` Менежерийн мөнгөн цэгт, эс бөгөөс `['pro']`). Ү7-ийн
 * `BiProRequiredBody`-оос ЗӨВХӨН `unlockTiers`-ээр ялгаатай (+ шинэ code/reason) — админы `tier-live.ts` `code`-оор танина.
 */
export type BiTierRequiredBody = {
  statusCode: 403
  error: 'Forbidden'
  code: BiTierRequiredCode
  reason: BiTierReason
  message: string
  detail: string | null
  unlockTiers: BiUnlockTier[]
}

const tierRequiredMessage = (code: BiTierRequiredCode, reason: BiTierReason, unlockTiers: readonly BiUnlockTier[]) => {
  if (code === BI_MANAGER_CHANNEL_REQUIRED_CODE) {
    return 'Менежер эрхтэй ч борлуулалтын суваг тохируулаагүй (ажилтны «Ажилтны тохиргоо» → «1С-ийн лавлахууд» → «Борлуулалтын суваг»)'
  }

  if (reason === 'unscopable') {
    return 'Энэ нэгтгэлийг борлуулалтын сувгаар огтлох боломжгүй — Pro эрх шаардлагатай (bi.pro:show)'
  }

  return unlockTiers.includes('manager')
    ? 'Менежер эсвэл Pro эрх шаардлагатай (bi.manager:show / bi.pro:show)'
    : 'Pro эрх шаардлагатай (bi.pro:show)'
}

/** Ү8 — `biAccessDecision`-ийн татгалзлаас 403-ийн бие. */
export const biTierRequiredBody = (denial: {
  code: BiTierRequiredCode
  reason: BiTierReason
  detail: string | null
  unlockTiers: readonly BiUnlockTier[]
}): BiTierRequiredBody => ({
  statusCode: 403,
  error: 'Forbidden',
  code: denial.code,
  reason: denial.reason,
  message: tierRequiredMessage(denial.code, denial.reason, denial.unlockTiers),
  detail: denial.detail,
  unlockTiers: [...denial.unlockTiers]
})

/* ─────────────────────────── Ү8 — хандалт (түвшин + суваг) ─────────────────────────── */

/**
 * Ү8 — ХЭРЭГЛЭГЧИЙН BI ХАНДАЛТ (D8-3). СЕРВЕР эрх (JWT) + `ErpScope`-оос гаргана; админ `/me/bi-access`-ээс уншина.
 *   `pro`     — `bi.pro:show` (компанийн хэмжээ; хүрээний хуваарилалттай бол тэр хүрээнд — docs/04);
 *   `manager` — `bi.manager:show` БА ≥1 борлуулалтын суваг (lower-case uuid, `_Reference24061`);
 *   `basic`   — бусад. `managerBlocked` — Менежер эрхтэй ч мөнгө нээгдэхгүй шалтгаан (эс бөгөөс `null`).
 */
export type BiAccess =
  | { tier: 'pro' }
  | { tier: 'manager'; salesChannels: string[] }
  | { tier: 'basic'; managerBlocked: BiManagerBlocked | null }

/** `resolveBiAccess`-ийн хүрээний оролт — `ErpScope`-ийн дэд хэлбэр (`linked` — хэрэглэгч ХН-ийн ажилтантай холбогдсон эсэх). */
export type BiAccessScope = { linked: boolean; salesChannels: readonly string[] }

/** Ү8 — ТҮВШИН ШИЙДЭХ (цэвэр). Дараалал: Pro > Менежер (≥1 суваг) > Basic. Суваг lower-case, давхардалгүй, эрэмбэлсэн. */
export const resolveBiAccess = (permissions: readonly string[] | null | undefined, scope: BiAccessScope): BiAccess => {
  if (hasBiPro(permissions)) return { tier: 'pro' }

  if (!hasBiManager(permissions)) return { tier: 'basic', managerBlocked: null }

  const channels = [...new Set(scope.salesChannels.map(id => id.trim().toLowerCase()).filter(Boolean))].sort()

  if (channels.length > 0) return { tier: 'manager', salesChannels: channels }

  return { tier: 'basic', managerBlocked: scope.linked ? 'no-channel' : 'no-employee' }
}

/** Ү7-ийн хоёр түвшний хандалт (`hasPro`) — хуучин нэрсийн (`biRouteDecision`, `biExportTierProblem`) дотоод хөрвүүлэлт. */
export const biLegacyAccess = (hasPro: boolean): BiAccess =>
  hasPro ? { tier: 'pro' } : { tier: 'basic', managerBlocked: null }

/** Түвшний эрэмбэ (`basic` 0 < `manager` 1 < `pro` 2). */
export const biTierRank = (tier: BiTier): number => BI_BOARD_TIERS.indexOf(tier)

/** Самбар/горимын түвшний эрх — `basic` → `null` (эх эрх л), `manager` → `bi.manager:show`, `pro` → `bi.pro:show`. */
export const biTierPermission = (tier: BiTier): string | null =>
  tier === 'pro' ? BI_PRO_PERMISSION : tier === 'manager' ? BI_MANAGER_PERMISSION : null

/** Хэрэглэгчийн ЭЗЭМШСЭН горимууд (сэлгүүр) — эрхээр л (сувгийн хүрээг ҮЛ ТООЦНО: сувгүй Менежер ИДЭВХГҮЙ сегмент харна). */
export const biHeldTiers = (permissions: readonly string[] | null | undefined): BiTier[] =>
  BI_BOARD_TIERS.filter(tier => {
    const permission = biTierPermission(tier)

    return permission === null || Boolean(permissions?.includes(permission))
  })

/* ─────────────────────────── Ү8 — хариуны хүрээний тэмдэг ─────────────────────────── */

/** Борлуулалтын суваг (`_Reference24061`): `id` — lower-case uuid, `name` — `_Description` (RA, OS, KA …). */
export type BiSalesChannelRef = { id: string; name: string }

/**
 * Ү8 — МЕНЕЖЕРИЙН ХАРИУНЫ ОРОЙН ТЭМДЭГ (`body.biScope`) — «энэ мөнгө ЗӨВХӨН эдгээр сувгийнх». Pro/Basic хариунд АЛГА.
 * Админы толгойн chip «Менежер · Суваг: RA, OS», AI каталог (docs/48) «хүрээг ишил» дүрэм.
 */
export const BI_SCOPE_KEY = 'biScope' as const

export type BiScopeMarker = { tier: 'manager'; salesChannels: BiSalesChannelRef[] }

/**
 * Ү8 — `GET /me/bi-access` (bi-boards модуль, `bi.boards:show`) — админы горимын эх (`useBiAccess`).
 *   `tier` — СЕРВЕРИЙН шийдвэр (`resolveBiAccess`); `held` — эрх (сувгаас үл хамааран);
 *   `scope.dims` — хэмжээс бүрийн хуваарилалтын ТОО (жагсаалт биш).
 */
export const BI_ME_ACCESS_PATH = 'me/bi-access' as const

export type BiMeAccessResponse = {
  tier: BiTier
  held: { manager: boolean; pro: boolean }
  managerBlocked: BiManagerBlocked | null
  salesChannels: BiSalesChannelRef[]
  scope: {
    restricted: boolean
    dims: {
      warehouses: number
      businessRegions: number
      deliveryZones: number
      routes: number
      brands: number
      salesChannels: number
    }
  }
}

/* ─────────────────────────── Ангилал (D7-1) ─────────────────────────── */

/** (d) Бүхэлдээ Pro домэйн. Basic хэрэглэгч `/bi/finance` дээр «Pro эрх шаардлагатай» төлөв харна. */
export const BI_PRO_DOMAINS: readonly BiDomainKey[] = ['finance']

/**
 * (b) Ажилтан/баг гэсэн хэмжээс — задаргааны `by` БА шүүлтийн facet түлхүүр (`/erp/1c-detail`, `/erp/orders`-тэй ИЖИЛ нэр).
 * ! docs/31 §4w: `manager` нь ХАСАГДСАН alias (`BI_RETIRED_FACET_KEYS`) — хаалганд ҮЛДЭНЭ (Basic 403 түрүүлнэ), бусад түвшинд
 * ! API 400 `BI_FILTER_RETIRED`. Менежер түвшинд баг шүүх/задлах сувгийн дотор нээлттэй (D8-5, `managerParams` алга) — ХЭВЭЭР.
 */
export const BI_PRO_DIMENSIONS = ['salesManager', 'manager'] as const

export type BiProDimension = (typeof BI_PRO_DIMENSIONS)[number]

/** (a) Мөнгөн нэгж — админы `MetricUnit`, экспортын `BiExportUnit`. */
export const BI_MONEY_UNITS = ['mnt'] as const

/** (a) `/erp/1c-detail/summary|series`-ийн `BiSalesMeasures` дахь мөнгөн талбар. Бусад (rows, qty, *Documents, *Qty, *Rows) — Basic. */
export const BI_SALES_MONEY_FIELDS = ['amount', 'amountVat', 'saleAmountVat', 'returnAmountVat', 'avgTicket'] as const

/** (a) `/erp/orders/summary`-ийн мөнгөн талбар (`totals`, `compareTotals`, `series[]`, `compareSeries[]`, `byStatus[]`). */
export const BI_ORDER_MONEY_FIELDS = ['amount'] as const

/** (a) `/erp/1c-detail/breakdown`-ийн мөнгөн хэмжигдэхүүн (`metric`). Анхдагч нь `amountVat` — параметргүй хүсэлт ч Pro. */
export const BI_BREAKDOWN_MONEY_METRICS = ['amountVat'] as const

/**
 * Pro ХЭСЭГ (админы `BiSectionKey`) — тэжээлгүй (`blocked`) хэмжигдэхүүний түвшинг тооцох статик дүрэмд: баг, төлөвлөгөө (b, c)
 * ба санхүүгийн дөрвөн хэсэг (d). Basic горимын «Хэсэг нэмэх» эдгээрийг санал болгохгүй.
 */
export const BI_PRO_SECTIONS = ['team', 'plan', 'receivables', 'credit', 'blacklist', 'collections'] as const

/* ─────────────────────────── Цэгийн бодлого (API хаалга) ─────────────────────────── */

/**
 * BI-ийн НЭГТГЭЛИЙН ЦЭГ БҮР — `@BiRoute(<түлхүүр>)`. Глобал угтваргүй зам (`app.setGlobalPrefix`-ээс өмнөх).
 *
 * ! ОРООГҮЙ (санаатай): `/erp/1c-detail` жагсаалт ба `/erp/1c-detail/export`, `/erp/1c-detail/lookups` — BI биш, ↗ жагсаалтын
 * ! дэлгэц; эрх нь жагсаалтын эрх (`erp.reports:list`). BI-ийн түвшин ЖАГСААЛТЫН эрхийг өөрчлөхгүй — дүр л хөшүүрэг (docs/31 §4t).
 * ! `/me/bi-boards`, `/bi/boards/*` — самбарын ӨРӨЛТ (тоо биш): `?tier=pro` → `bi.pro:show` (`reason: 'board'`), `BiBoardsService`.
 */
export const BI_ROUTE_KEYS = [
  'erp.1c-detail.summary',
  'erp.1c-detail.series',
  'erp.1c-detail.breakdown',
  'erp.1c-detail.customers',

  /* docs/31 §4v.6 (drill-down) — ТӨГСГӨЛД биш, борлуулалтын бүлэгт: түлхүүрийн ДАРААЛАЛ утгагүй (map), нэмэх л. */
  'erp.1c-detail.promos',
  'erp.orders.summary',
  'erp.plans.performance',
  'erp.bi.stock',
  'erp.bi.stock.breakdown',
  'erp.bi.stock.expiry',
  'erp.bi.finance.receivables',
  'erp.bi.finance.credit',
  'erp.bi.finance.blacklist',
  'erp.bi.finance.loans',
  'erp.bi.finance.payments',
  'erp.bi.finance.payments.channels',
  'hr.bi.workforce',
  'hr.bi.movement',
  'timesheet.bi.attendance',
  'timesheet.bi.leave',
  'delivery.bi.runs',
  'delivery.bi.runs.vehicles',
  'delivery.bi.snapshot',
  'delivery.bi.returns',
  'warehouse.bi.batches',
  'warehouse.bi.picking',
  'warehouse.bi.returns',
  'warehouse.bi.queue',
  'warehouse.bi.gates',
  'bi.export.xlsx'
] as const

export type BiRouteKey = (typeof BI_ROUTE_KEYS)[number]

/**
 * БУУЛГАЛТ: `containers` доторх объектын `fields`-ийг `null` болгоно. Зам нь цэгээр (`totals`), `[]` төгсгөл = массивын
 * элемент бүр (`series[]`; `null` элемент хэвээр). Байхгүй контейнер/талбар алгасагдана (талбар НЭМЭГДЭХГҮЙ).
 */
export type BiRedactSpec = { containers: readonly string[]; fields: readonly string[] }

/** Query параметр → Pro утгууд. `default` = параметргүй үеийн сервисийн анхдагч (жишээ нь `metric` → `amountVat`). */
export type BiProParam = { values: readonly string[]; default?: string; reason: 'dimension' | 'measure' }

export type BiRoutePolicy = {
  method: 'GET' | 'POST'

  /** Глобал угтваргүй, эхний `/`-гүй (`erp/1c-detail/summary`). */
  path: string
  domain: BiDomainKey

  /** Цэг бүхэлдээ Pro — Basic хэрэглэгчид 403. */
  pro?: 'domain' | 'endpoint'

  /** Query параметрийн Pro утга (`by`, `metric`) — 403. */
  proParams?: Readonly<Record<string, BiProParam>>

  /** Хоосон биш бол Pro болох шүүлтийн facet (`salesManager`, `manager`) — 403 `filter`. */
  proFilters?: readonly string[]

  /** Мөнгөн талбарыг `null` + `redacted` (Basic хэрэглэгч). */
  redact?: BiRedactSpec

  /** Бие-д суурилсан шалгалт (`/bi/export/xlsx` → `biExportTierProblem`) — query-ийн дүрэм хамаарахгүй. */
  body?: 'export'

  /**
   * Ү8 (D8-4) — МЕНЕЖЕРИЙН БОДЛОГО, ЦЭГ БҮРД ИЛ (spec: түлхүүр БҮР заасан):
   *   `money` — Менежерт мөнгө НЭЭЛТТЭЙ, мөр нь сувгаар огтлогдсон (`applied.salesChannel` post-assert, API);
   *   `basic` — Менежер = Basic (сувгаар огтлогдохгүй домэйн: агуулах, ХН, түгээлт …);
   *   `deny`  — Менежерт 403 `unscopable` (сувгаар огтлох боломжгүй — төлөвлөгөө, D8-6; Ү8b-д `money`).
   * `body` цэгт (`/bi/export/xlsx`) `money` = «Менежерийн домэйны мөнгөн хавтан зөвшөөрөгдөнө» (`biExportAccessProblem`).
   */
  manager: BiManagerPolicy

  /**
   * Ү8 (D8-5) — Менежерийн `proParams`/`proFilters`: анхдагч (`undefined`) — Менежер Pro шиг (баг/хүний задаргаа, `metric=
   * amountVat` СУВГИЙН ДОТОР); `'basic'` — Менежерт Basic-ийн параметрийн дүрэм (D8-5-ыг буцаах НЭГ туг).
   */
  managerParams?: 'basic'
}

export const BI_MANAGER_POLICIES = ['money', 'basic', 'deny'] as const

export type BiManagerPolicy = (typeof BI_MANAGER_POLICIES)[number]

const SALES_FILTERS = BI_PRO_DIMENSIONS

const SALES_REDACT_SUMMARY: BiRedactSpec = { containers: ['totals', 'compareTotals'], fields: BI_SALES_MONEY_FIELDS }

const SALES_REDACT_SERIES: BiRedactSpec = {
  containers: ['totals', 'compareTotals', 'series[]', 'compareSeries[]'],
  fields: BI_SALES_MONEY_FIELDS
}

const ORDERS_REDACT: BiRedactSpec = {
  containers: ['totals', 'compareTotals', 'series[]', 'compareSeries[]', 'byStatus[]'],
  fields: BI_ORDER_MONEY_FIELDS
}

/** ТҮВШНИЙ ХҮСНЭГТ — docs/31 §4t-ийн хүснэгттэй 1:1. */
export const BI_ROUTE_TIERS: Readonly<Record<BiRouteKey, BiRoutePolicy>> = {
  /* ── Борлуулалт (1С) ── */
  'erp.1c-detail.summary': {
    method: 'GET',
    path: 'erp/1c-detail/summary',
    domain: 'sales',
    proFilters: SALES_FILTERS,
    redact: SALES_REDACT_SUMMARY,
    manager: 'money'
  },
  'erp.1c-detail.series': {
    method: 'GET',
    path: 'erp/1c-detail/series',
    domain: 'sales',
    proFilters: SALES_FILTERS,
    redact: SALES_REDACT_SERIES,
    manager: 'money'
  },
  'erp.1c-detail.breakdown': {
    method: 'GET',
    path: 'erp/1c-detail/breakdown',
    domain: 'sales',
    proParams: {
      by: { values: BI_PRO_DIMENSIONS, reason: 'dimension' },
      metric: { values: BI_BREAKDOWN_MONEY_METRICS, default: 'amountVat', reason: 'measure' }
    },
    proFilters: SALES_FILTERS,
    manager: 'money'
  },
  'erp.1c-detail.customers': {
    method: 'GET',
    path: 'erp/1c-detail/customers',
    domain: 'sales',
    proFilters: SALES_FILTERS,
    manager: 'money'
  },
  /*
   * docs/31 §4v.6 — сар бүрийн биелсэн промо (docs/47 §2.4). Бодлого = `bi-drill.ts`-ийн `BI_PROMOS_ROUTE_POLICY` (ЯГ ТЭР —
   * борлуулалт, баг/менежерийн шүүлт Pro, мөнгө (`amount`) БҮХ контейнерт буулгана, Менежерт сувгийн дотор мөнгө).
   */
  'erp.1c-detail.promos': BI_PROMOS_ROUTE_POLICY,
  'erp.orders.summary': {
    method: 'GET',
    path: 'erp/orders/summary',
    domain: 'sales',
    proFilters: ['salesManager'],
    redact: ORDERS_REDACT,
    manager: 'money'
  },
  'erp.plans.performance': {
    method: 'GET',
    path: 'erp/plans/performance',
    domain: 'sales',
    pro: 'endpoint',
    manager: 'deny'
  },

  /* ── Агуулах — 1С үлдэгдэл (ширхэг, SKU; мөнгө алга) ── */
  'erp.bi.stock': { method: 'GET', path: 'erp/bi/stock', domain: 'warehouse', manager: 'basic' },
  'erp.bi.stock.breakdown': { method: 'GET', path: 'erp/bi/stock/breakdown', domain: 'warehouse', manager: 'basic' },
  'erp.bi.stock.expiry': { method: 'GET', path: 'erp/bi/stock/expiry', domain: 'warehouse', manager: 'basic' },

  /* ── Санхүү — Basic-д бүхэлдээ хаалттай (D7-1 d); Ү8: Менежерт өөрийн сувгаар (D8-7, мөр шүүж нийлбэр дахин тооцно) ── */
  'erp.bi.finance.receivables': {
    method: 'GET',
    path: 'erp/bi/finance/receivables',
    domain: 'finance',
    pro: 'domain',
    manager: 'money'
  },
  'erp.bi.finance.credit': {
    method: 'GET',
    path: 'erp/bi/finance/credit',
    domain: 'finance',
    pro: 'domain',
    manager: 'money'
  },
  'erp.bi.finance.blacklist': {
    method: 'GET',
    path: 'erp/bi/finance/blacklist',
    domain: 'finance',
    pro: 'domain',
    manager: 'money'
  },
  'erp.bi.finance.loans': {
    method: 'GET',
    path: 'erp/bi/finance/loans',
    domain: 'finance',
    pro: 'domain',
    manager: 'money'
  },
  'erp.bi.finance.payments': {
    method: 'GET',
    path: 'erp/bi/finance/payments',
    domain: 'finance',
    pro: 'domain',
    manager: 'money'
  },
  'erp.bi.finance.payments.channels': {
    method: 'GET',
    path: 'erp/bi/finance/payments/channels',
    domain: 'finance',
    pro: 'domain',
    manager: 'money'
  },

  /* ── ХН, ирц (тоо; хэлтэс/байршил нь бүлэг, ажилтны гүйцэтгэл биш) ── */
  'hr.bi.workforce': { method: 'GET', path: 'hr/bi/workforce', domain: 'hr', manager: 'basic' },
  'hr.bi.movement': { method: 'GET', path: 'hr/bi/movement', domain: 'hr', manager: 'basic' },
  'timesheet.bi.attendance': { method: 'GET', path: 'timesheet/bi/attendance', domain: 'hr', manager: 'basic' },
  'timesheet.bi.leave': { method: 'GET', path: 'timesheet/bi/leave', domain: 'hr', manager: 'basic' },

  /* ── Түгээлт (тоо; машин = хөрөнгө, багийн бүрэлдэхүүн = тоо) ── */
  'delivery.bi.runs': { method: 'GET', path: 'delivery/bi/runs', domain: 'delivery', manager: 'basic' },
  'delivery.bi.runs.vehicles': {
    method: 'GET',
    path: 'delivery/bi/runs/vehicles',
    domain: 'delivery',
    manager: 'basic'
  },
  'delivery.bi.snapshot': { method: 'GET', path: 'delivery/bi/snapshot', domain: 'delivery', manager: 'basic' },
  'delivery.bi.returns': { method: 'GET', path: 'delivery/bi/returns', domain: 'delivery', manager: 'basic' },

  /* ── Агуулах — өөрийн бааз (тоо) ── */
  'warehouse.bi.batches': { method: 'GET', path: 'warehouse/bi/batches', domain: 'warehouse', manager: 'basic' },
  'warehouse.bi.picking': { method: 'GET', path: 'warehouse/bi/picking', domain: 'warehouse', manager: 'basic' },
  'warehouse.bi.returns': { method: 'GET', path: 'warehouse/bi/returns', domain: 'warehouse', manager: 'basic' },
  'warehouse.bi.queue': { method: 'GET', path: 'warehouse/bi/queue', domain: 'warehouse', manager: 'basic' },
  'warehouse.bi.gates': { method: 'GET', path: 'warehouse/bi/gates', domain: 'warehouse', manager: 'basic' },

  /* ── Excel (ачаа нь домэйнтэй — бие-д суурилсан шалгалт; Ү8: Менежер — борлуулалт/санхүүгийн мөнгөн хавтан) ── */
  'bi.export.xlsx': { method: 'POST', path: 'bi/export/xlsx', domain: 'sales', body: 'export', manager: 'money' }
}

/** Админы хүсэлтийн зам (`/erp/1c-detail/series`) → түлхүүр. Олдохгүй бол `null` (BI цэг биш). */
export const biRouteKeyOf = (method: BiRoutePolicy['method'], path: string): BiRouteKey | null => {
  const normalized = path.replace(/^\/+/, '').replace(/\?.*$/, '')

  return BI_ROUTE_KEYS.find(key => BI_ROUTE_TIERS[key].method === method && BI_ROUTE_TIERS[key].path === normalized) ?? null
}

/* ─────────────────────────── Шийдвэр ─────────────────────────── */

/** Ү7-ийн шийдвэр (`biRouteDecision`) — хэлбэр ХЭВЭЭР (Basic/Pro хариу байт-аа тэнцүү, D8-3). */
export type BiTierDecision =
  | { allow: true; redact: BiRedactSpec | null }
  | { allow: false; reason: BiProReason; detail: string | null }

/**
 * Ү8 — буулгалтын ТЭМДГИЙН «үр» (`fields`-гүй): `tier` — хамгийн бага нээх түвшин, `reason` — `measure` (түвшин) эсвэл
 * `channel` (Менежер эрхтэй ч суваггүй / post-assert баталж чадаагүй), `unlockTiers` — нээх түвшнүүд.
 */
export type BiRedactionSeed = { tier: BiUnlockTier; reason: BiRedactionReason; unlockTiers?: BiUnlockTier[] }

/**
 * Ү8 — ХАНДАЛТЫН ШИЙДВЭР (цэвэр, `biAccessDecision`).
 *   зөвшөөрсөн: `redact` — буулгах талбар + тэмдгийн үр (эсвэл `null`); `assertSalesChannels` — Менежерийн мөнгөн цэгт
 *               handler-ийн ДАРАА хариуны `applied.salesChannel` ⊆ энэ жагсаалт (хоосон биш) эсэхийг API ШАЛГАНА (D8-4);
 *   татгалзсан: `code`/`reason`/`detail`/`unlockTiers` → `biTierRequiredBody`.
 */
export type BiAccessDecision =
  | {
      allow: true
      redact: { spec: BiRedactSpec; marker: BiRedactionSeed } | null
      assertSalesChannels: readonly string[] | null
    }
  | { allow: false; code: BiTierRequiredCode; reason: BiTierReason; detail: string | null; unlockTiers: BiUnlockTier[] }

const firstValue = (value: unknown): string | undefined => {
  if (typeof value === 'string') return value
  if (Array.isArray(value) && typeof value[0] === 'string') return value[0]

  return undefined
}

/**
 * ! Гүнзгий хамгаалалт (интеграцийн засвар): объект хэлбэрийн утга (`salesManager[a]=x` — `extended` query parser) ч
 * ! «хоосон биш» — Express 5-ын анхдагч parser объект үүсгэдэггүй, DTO 400 өгдөг ч хаалга түүнд найдахгүй.
 */
const nonEmpty = (value: unknown): boolean =>
  typeof value === 'string'
    ? value.trim().length > 0
    : Array.isArray(value)
      ? value.some(nonEmpty)
      : value !== null && typeof value === 'object'
        ? Object.values(value).some(nonEmpty)
        : typeof value === 'number' || typeof value === 'boolean'

/** Цэгийн нээх түвшнүүд — Менежерийн мөнгөн цэгт `['manager','pro']`, бусад `['pro']`. */
export const biRouteUnlockTiers = (route: BiRouteKey): BiUnlockTier[] =>
  BI_ROUTE_TIERS[route].manager === 'money' ? ['manager', 'pro'] : ['pro']

/** Basic-ийн параметр/шүүлтийн дүрэм (Ү7) — татгалзлын шалтгаан эсвэл `null`. */
const basicParamDenial = (
  policy: BiRoutePolicy,
  query: Readonly<Record<string, unknown>>
): { reason: BiProReason; detail: string | null } | null => {
  for (const [param, rule] of Object.entries(policy.proParams ?? {})) {
    const value = firstValue(query[param]) ?? rule.default

    if (value !== undefined && rule.values.includes(value)) return { reason: rule.reason, detail: `${param}=${value}` }
  }

  for (const facet of policy.proFilters ?? []) {
    if (nonEmpty(query[facet])) return { reason: 'filter', detail: facet }
  }

  return null
}

/**
 * Ү8 — ХҮСЭЛТИЙН ШИЙДВЭР (цэвэр) — гурван түвшин (docs/31 §4u, design §2.2):
 *   1. `pro` → үргэлж зөвшөөрнө, буулгалтгүй.
 *   2. `manager` + `money` → зөвшөөрнө, буулгалтгүй, `assertSalesChannels` (post-assert, D8-4). `managerParams: 'basic'` бол
 *      параметр/шүүлтэд Basic-ийн дүрэм (`unlockTiers: ['pro']`).
 *   3. `manager` + `deny` → 403 `BI_PRO_REQUIRED` `unscopable`, `unlockTiers: ['pro']`.
 *   4. Бусад (Basic, эсвэл Менежер + `basic` бодлого) → Ү7-ийн Basic дүрэм ӨӨРЧЛӨЛТГҮЙ; татгалзал/буулгалт бүр `unlockTiers`-тэй.
 *      `managerBlocked` + `money` цэг → `BI_MANAGER_CHANNEL_REQUIRED`, `reason: 'channel'`, `detail: no-employee|no-channel`
 *      (буулгалтын тэмдэг `reason: 'channel'`).
 * ! `body: 'export'` цэгт query-ийн дүрэм хамаарахгүй (`biExportAccessProblem`) — зөвшөөрнө (interceptor алгасна).
 */
export const biAccessDecision = (
  route: BiRouteKey,
  query: Readonly<Record<string, unknown>>,
  access: BiAccess
): BiAccessDecision => {
  const policy = BI_ROUTE_TIERS[route]

  if (access.tier === 'pro' || policy.body) return { allow: true, redact: null, assertSalesChannels: null }

  if (access.tier === 'manager' && policy.manager === 'money') {
    const denial = policy.managerParams === 'basic' ? basicParamDenial(policy, query) : null

    if (denial) return { allow: false, code: BI_PRO_REQUIRED_CODE, ...denial, unlockTiers: ['pro'] }

    return { allow: true, redact: null, assertSalesChannels: [...access.salesChannels] }
  }

  if (access.tier === 'manager' && policy.manager === 'deny') {
    return { allow: false, code: BI_PRO_REQUIRED_CODE, reason: 'unscopable', detail: null, unlockTiers: ['pro'] }
  }

  const unlockTiers = biRouteUnlockTiers(route)
  const blocked = access.tier === 'basic' && policy.manager === 'money' ? access.managerBlocked : null
  const deny = (reason: BiProReason, detail: string | null): BiAccessDecision =>
    blocked
      ? { allow: false, code: BI_MANAGER_CHANNEL_REQUIRED_CODE, reason: 'channel', detail: blocked, unlockTiers }
      : { allow: false, code: BI_PRO_REQUIRED_CODE, reason, detail, unlockTiers }

  if (policy.pro) return deny(policy.pro, null)

  const denial = basicParamDenial(policy, query)

  if (denial) return deny(denial.reason, denial.detail)

  if (!policy.redact) return { allow: true, redact: null, assertSalesChannels: null }

  const marker: BiRedactionSeed = blocked
    ? { tier: unlockTiers[0]!, reason: 'channel', unlockTiers }
    : { tier: unlockTiers[0]!, reason: 'measure', unlockTiers }

  return { allow: true, redact: { spec: policy.redact, marker }, assertSalesChannels: null }
}

/**
 * ХҮСЭЛТИЙН ШИЙДВЭР (Ү7, цэвэр) — хоёр түвшин (`hasPro`). Ү8-д `biAccessDecision`-ий хөрвүүлэлт: хэлбэр ХЭВЭЭР (Basic/Pro
 * хариу байт-аа тэнцүү). Админы Ү7 тооцоо (`biRequestTier`) ба API-ийн Ү7 хаалга ЭНИЙГ.
 *
 * ! Pro эрхтэй → үргэлж зөвшөөрнө, буулгалтгүй. Дараалал: цэг/домэйн → параметр (by, metric-ийн анхдагч ч) → шүүлт → буулгалт.
 * ! `body: 'export'` цэгт query-ийн дүрэм хамаарахгүй (`biExportTierProblem`).
 */
export const biRouteDecision = (
  route: BiRouteKey,
  query: Readonly<Record<string, unknown>>,
  hasPro: boolean
): BiTierDecision => {
  if (hasPro) return { allow: true, redact: null }

  const policy = BI_ROUTE_TIERS[route]

  if (policy.body) return { allow: true, redact: policy.redact ?? null }

  const decision = biAccessDecision(route, query, biLegacyAccess(false))

  /* ! Basic + `managerBlocked: null` → `code` үргэлж `BI_PRO_REQUIRED`, `reason` ∈ `BI_PRO_REASONS`. */
  if (!decision.allow) return { allow: false, reason: decision.reason as BiProReason, detail: decision.detail }

  return { allow: true, redact: decision.redact?.spec ?? null }
}

/* ─────────────────────────── Буулгалт (redaction) ─────────────────────────── */

/**
 * БУУЛГАЛТЫН ТЭМДЭГ — хариуны ОРОЙ дээр (`body.redacted`). Зөвхөн ямар нэг талбар буусан үед; Pro хэрэглэгчид АЛГА.
 *
 * ! Админы parser: `fields`-д байгаа түлхүүр `null` байж болно (түгжээтэй хэсэг), байхгүй түлхүүр `null` бол ХЭЛБЭР ЗӨРСӨН
 * ! (offline/invalid) — «0»-ээр ХЭЗЭЭ Ч нөхөхгүй.
 */
export type BiRedaction = {
  /** Хамгийн бага нээх түвшин (Ү7: үргэлж `pro`; Ү8: Менежерийн мөнгөн цэгт `manager`). */
  tier: BiUnlockTier
  reason: BiRedactionReason
  fields: string[]

  /**
   * Ү8 — нээх түвшнүүд. НЭМЭЛТ: Ү7-ийн хаалга (`redactBiPayload(body, spec)` — тэмдгийн үр өгөөгүй) ТАВИХГҮЙ; API-SCOPE-TIER
   * хаалгаа `biAccessDecision` руу шилжүүлэхэд Basic хариунд ч гарна (design §2.2 п.4).
   */
  unlockTiers?: BiUnlockTier[]
}

/** Ү8 — буулгалтын шалтгаан: `measure` — түвшин (мөнгө); `channel` — Менежерийн суваг тохируулаагүй / баталгаагүй. */
export const BI_REDACTION_REASONS = ['measure', 'channel'] as const

export type BiRedactionReason = (typeof BI_REDACTION_REASONS)[number]

/** Ү7-ийн тэмдгийн үр — `redactBiPayload`-ийн анхдагч (`unlockTiers`-гүй, байт-аа тэнцүү). */
const LEGACY_REDACTION: BiRedactionSeed = { tier: 'pro', reason: 'measure' }

export const BI_REDACTION_KEY = 'redacted' as const

const isObject = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value)

const nullFields = (
  target: Record<string, unknown>,
  fields: readonly string[],
  hit: Set<string>
): Record<string, unknown> => {
  let copy: Record<string, unknown> | null = null

  for (const field of fields) {
    if (!(field in target) || target[field] === null) continue

    copy ??= { ...target }
    copy[field] = null
    hit.add(field)
  }

  return copy ?? target
}

/** Нэг контейнерын замыг (`a.b[]`) дагаж ХУУЛБАР буцаана — эх объект ӨӨРЧЛӨГДӨХГҮЙ. */
const redactPath = (
  node: unknown,
  segments: readonly string[],
  fields: readonly string[],
  hit: Set<string>
): unknown => {
  if (segments.length === 0) return isObject(node) ? nullFields(node, fields, hit) : node

  const [head, ...rest] = segments
  const each = head!.endsWith('[]')
  const key = each ? head!.slice(0, -2) : head!

  if (!isObject(node) || !(key in node)) return node

  const child = node[key]
  let next: unknown

  if (each) {
    if (!Array.isArray(child)) return node

    let changed = false
    const mapped = child.map(item => {
      const out = redactPath(item, rest, fields, hit)

      if (out !== item) changed = true

      return out
    })

    next = changed ? mapped : child
  } else {
    next = redactPath(child, rest, fields, hit)
  }

  return next === child ? node : { ...node, [key]: next }
}

/**
 * Basic хэрэглэгчийн хариуг БУУЛГАНА (цэвэр, copy-on-write). Буусан талбар байхгүй бол ЭХ объектыг буцаана.
 * Буусан бол `redacted: { tier: 'pro', reason: 'measure', fields }` (буусан талбарын нэр, эрэмбэлсэн) нэмнэ.
 * Ү8: `seed` (`biAccessDecision`-ийн `redact.marker`) өгвөл тэмдэг нь түүнийх (`tier`, `reason`, `unlockTiers`).
 */
export const redactBiPayload = <T>(body: T, spec: BiRedactSpec | null, seed: BiRedactionSeed = LEGACY_REDACTION): T => {
  if (!spec || !isObject(body)) return body

  const hit = new Set<string>()
  let out: unknown = body

  for (const container of spec.containers) {
    out = redactPath(out, container.split('.'), spec.fields, hit)
  }

  if (hit.size === 0) return body

  const marker: BiRedaction = {
    tier: seed.tier,
    reason: seed.reason,
    fields: [...hit].sort(),
    ...(seed.unlockTiers ? { unlockTiers: [...seed.unlockTiers] } : {})
  }

  return { ...(out as Record<string, unknown>), [BI_REDACTION_KEY]: marker } as T
}

/** Админы parser-т: хариунд тухайн талбар буусан уу. */
export const isBiFieldRedacted = (body: unknown, field: string): boolean => {
  if (!isObject(body)) return false

  const marker = body[BI_REDACTION_KEY]

  return isObject(marker) && Array.isArray(marker.fields) && marker.fields.includes(field)
}

/* ─────────────────────────── Админы түвшин (MetricDef ↔ энэ хүснэгт) ─────────────────────────── */

/**
 * Хавтан/хэсгийн НЭГ ХЭСГИЙН хүсэлт — админы `feedRequest`-ээс (`path`, `query`) + тэр хэсгийн УНШДАГ хариуны талбар (`reads`).
 * `reads` — буулгалтын `fields`-тэй тулгах талбарын нэр (`amountVat`, `saleDocuments`, `orders` …).
 */
export type BiTierRequest = { method?: BiRoutePolicy['method']; path: string; query: Readonly<Record<string, unknown>>; reads: readonly string[] }

/**
 * Хүсэлт Basic хэрэглэгчид бүрэн харагдах уу: цэг танигдсан, зөвшөөрөгдсөн, уншдаг талбарын нэг нь ч буугаагүй → `basic`.
 * Танихгүй цэг → `pro` (аюулгүй тал — spec үүнийг бүртгэлд ЗӨРЧИЛ гэж барина).
 */
export const biRequestTier = (request: BiTierRequest): 'basic' | 'pro' => {
  const route = biRouteKeyOf(request.method ?? 'GET', request.path)

  if (!route) return 'pro'

  const decision = biRouteDecision(route, request.query, false)

  if (!decision.allow) return 'pro'

  return decision.redact && request.reads.some(field => decision.redact!.fields.includes(field)) ? 'pro' : 'basic'
}

/**
 * Ү8 — ХҮСЭЛТИЙН ХАМГИЙН БАГА НЭЭХ ТҮВШИН (админы `MetricDef.tier`-ийн гурван түвшний тооцоо):
 *   `basic`   — Basic хэрэглэгчид бүрэн (Ү7-ийн `biRequestTier === 'basic'`);
 *   `manager` — сувагтай Менежерт бүрэн (`biAccessDecision` зөвшөөрч, буулгалтгүй — мөр нь сувгаар огтлогдоно);
 *   `pro`     — бусад (танихгүй цэг ч — аюулгүй тал).
 */
export const biRequestMinTier = (request: BiTierRequest): BiTier => {
  if (biRequestTier(request) === 'basic') return 'basic'

  const route = biRouteKeyOf(request.method ?? 'GET', request.path)

  if (!route) return 'pro'

  const probe: BiAccess = { tier: 'manager', salesChannels: ['00000000-0000-0000-0000-000000000000'] }
  const decision = biAccessDecision(route, request.query, probe)

  if (!decision.allow) return 'pro'

  return decision.redact && request.reads.some(field => decision.redact!.spec.fields.includes(field)) ? 'pro' : 'manager'
}

/**
 * ХАВТАНГИЙН ТҮВШИН — админы `MetricDef.tier`-ийн утга.
 *   `basic` — бүх хэсэг Basic; `pro` — бүх хэсэг Pro (карт бүхэлдээ түгжигдэнэ);
 *   `mixed` — зарим хэсэг Pro («Борлуулалт» хэсэг: Падааны тоо Basic, Орлого/Дундаж падаан Pro) — Basic хэсэг зурагдаж,
 *             Pro хэсэг тус бүр түгжигдэнэ.
 */
export type BiTileTier = BiBoardTier | 'mixed'

export const biTileTier = (parts: readonly BiTier[]): BiTileTier => {
  if (parts.length === 0) return 'basic'

  const first = parts[0]!

  /* ! Ү8: бүгд ИЖИЛ түвшин → тэр түвшин (`basic`/`manager`/`pro`); холимог → `mixed` (Ү7-д зөвхөн basic/pro). */
  return parts.every(part => part === first) ? first : 'mixed'
}

/**
 * ТЭЖЭЭЛГҮЙ (blocked/retired) хэмжигдэхүүний СТАТИК дүрэм — домэйн, нэгж, хэсгээр. Тэжээлтэй хэмжигдэхүүнд `biRequestTier` ЭХ.
 */
export const biStaticTier = (metric: { domain: string; unit: string; section?: string | null }): BiBoardTier =>
  (BI_PRO_DOMAINS as readonly string[]).includes(metric.domain) ||
  (BI_MONEY_UNITS as readonly string[]).includes(metric.unit) ||
  (metric.section != null && (BI_PRO_SECTIONS as readonly string[]).includes(metric.section))
    ? 'pro'
    : 'basic'

/**
 * Ү8 — ТЭЖЭЭЛГҮЙ хэмжигдэхүүний ГУРВАН түвшний статик дүрэм. Ү7-ийн `biStaticTier === 'pro'` хэмжигдэхүүнээс:
 *   төлөвлөгөөний хэсэг (`plan`) → `pro` (Ү8b хүртэл, D8-6); Менежерийн домэйн (борлуулалт, санхүү) → `manager`;
 *   бусад домэйны мөнгө (`delivery.collectedAmount`, `warehouse.stockValue` …) → `pro`.
 */
export const BI_MANAGER_LOCKED_SECTIONS = ['plan'] as const

export const biStaticMinTier = (metric: { domain: string; unit: string; section?: string | null }): BiTier => {
  if (biStaticTier(metric) === 'basic') return 'basic'
  if (metric.section != null && (BI_MANAGER_LOCKED_SECTIONS as readonly string[]).includes(metric.section)) return 'pro'

  return (BI_MANAGER_DOMAINS as readonly string[]).includes(metric.domain) ? 'manager' : 'pro'
}

/* ─────────────────────────── Экспорт ─────────────────────────── */

/**
 * `POST /bi/export/xlsx` — Basic хэрэглэгчийн ачаа: Pro домэйн → `domain`; `omitted` биш хавтанд `mnt` нэгжтэй багана эсвэл
 * гарчиг → `export`. `omitted.kind === 'pro'` (түгжээтэй хавтан, гарчиг л) ЗӨВШӨӨРӨГДӨНӨ. Pro эрхтэй → `null`.
 *
 * ! Экспорт дэлгэцээс (render-from-screen, docs/31 §4o) — Basic хэрэглэгч Pro өгөгдлийг серверээс АВЧ ЧАДАХГҮЙ тул энэ нь
 * ! гүнзгий хамгаалалт: админы алдаа Pro тоог Excel-д ЧИМЭЭГҮЙ оруулахаас сэргийлнэ.
 */
export type BiExportTierPayload = {
  domain: string
  tiles: readonly {
    id: string
    headline: { unit: string } | null
    table: { columns: readonly { unit: string }[] } | null
    omitted: { kind: string } | null
  }[]
}

/**
 * Ү8 — Excel-ийн ачааны шалгалт (гурван түвшин):
 *   `pro` → `null`; `manager` → Менежерийн домэйнд (борлуулалт, санхүү) мөнгө зөвшөөрөгдөнө (`null`), бусад домэйнд Basic-ийн
 *   дүрэм; `basic` → Ү7-ийн дүрэм (Pro домэйн → `domain`, мөнгөн багана/гарчиг → `export`).
 * ! Сервер Менежерийн ачаанд «Түвшин: Менежер · Суваг: …»-г ХЭРЭГЛЭГЧИЙН сувгаас тамгална (API-SCOPE-TIER, design §4.1).
 */
export const biExportAccessProblem = (
  payload: BiExportTierPayload,
  access: BiAccess
): { reason: 'domain' | 'export'; detail: string | null } | null => {
  if (access.tier === 'pro') return null
  if (access.tier === 'manager' && (BI_MANAGER_DOMAINS as readonly string[]).includes(payload.domain)) return null
  if ((BI_PRO_DOMAINS as readonly string[]).includes(payload.domain)) return { reason: 'domain', detail: payload.domain }

  const money = (unit: string) => (BI_MONEY_UNITS as readonly string[]).includes(unit)

  for (const tile of payload.tiles) {
    if (tile.omitted) continue
    if ((tile.headline && money(tile.headline.unit)) || tile.table?.columns.some(column => money(column.unit))) {
      return { reason: 'export', detail: tile.id }
    }
  }

  return null
}

/** Ү7-ийн нэр (`hasPro`) — `biExportAccessProblem`-ийн хөрвүүлэлт, хариу ИЖИЛ. */
export const biExportTierProblem = (
  payload: BiExportTierPayload,
  hasPro: boolean
): { reason: 'domain' | 'export'; detail: string | null } | null => biExportAccessProblem(payload, biLegacyAccess(hasPro))

/* ─────────────────────────── Pro самбар (D7-3) ─────────────────────────── */

/**
 * `?tier=` — самбарын цэгүүдийн (`/me/bi-boards/:domain`, `/bi/boards/:domain/published`) түвшин. Анхдагч `basic` (Ү5-ийн
 * зан төлөв өөрчлөгдөхгүй). `pro` → `bi.pro:show` (403 `BI_PRO_REQUIRED`, `reason: 'board'`).
 */
export const BI_BOARD_TIER_PARAM = 'tier' as const

/**
 * Pro самбарын төлвийн ялгагч — `state.kind === 'pro'`. Сервер `tier=pro` PUT-д ЗААВАЛ, `tier=basic` PUT-д ХОРИОТОЙ (400) —
 * хоёр түвшний JSON хольж хадгалахгүй. Хэлбэрийн эзэн нь админы Pro адаптер (`views/apps/bi/tiers/pro-board.ts`).
 */
export const BI_PRO_BOARD_KIND = 'pro' as const

/**
 * Ү8 (D8-11) — Менежер самбарын ялгагч `state.kind === 'manager'` (Pro-гийн ижил механизм: нийтлэгдсэн Basic ишлэл +
 * Менежерийн хэсэг; Pro-г ИШЛЭХГҮЙ). Хэлбэрийн эзэн — админы түвшний адаптер (ADMIN-TIER).
 */
export const BI_MANAGER_BOARD_KIND = 'manager' as const

/**
 * Ү8 — самбарын түвшин → `state.kind`: `basic` → `null` (өргөтгөлийн kind ХОРИОТОЙ), `manager` → `'manager'`, `pro` → `'pro'`.
 * Сервер: өргөтгөлийн түвшний PUT-д `state.kind === biBoardKindOf(tier)` ЗААВАЛ, Basic-д аль ч өргөтгөлийн kind 400.
 */
export const biBoardKindOf = (tier: BiTier): typeof BI_MANAGER_BOARD_KIND | typeof BI_PRO_BOARD_KIND | null =>
  tier === 'pro' ? BI_PRO_BOARD_KIND : tier === 'manager' ? BI_MANAGER_BOARD_KIND : null

/** Ү8 — өргөтгөлийн самбарын kind-ууд (Basic мөрөнд ХАДГАЛАГДАХГҮЙ). */
export const BI_EXTENSION_BOARD_KINDS = [BI_MANAGER_BOARD_KIND, BI_PRO_BOARD_KIND] as const

/** Админы URL: `?tier=pro|basic` (самбарын горим). Байхгүй бол эрхтэй хүнд сүүлийн сонголт, эс бөгөөс `pro`. */
export const BI_TIER_QUERY_KEY = 'tier' as const

/* ─────────────────────────── Ү8 — AI каталог (x-bi) ─────────────────────────── */

/**
 * Ү8 — цэгийн ТҮВШНИЙ ЭРХ (docs/48 §3.6, `x-bi.tierPermissions`): Pro хаалгатай (`pro`/`proParams`/`proFilters`/`redact`/`body`)
 * цэгт `pro`; Менежерийн мөнгөн цэгт (`manager: 'money'`) нэмж `manager`. Basic цэг → `{}`.
 * ! OpenAPI-д холбох (`bi-openapi.catalog.ts` `biXTierPermissions`) + `openapi:export` + docs/48 — API-SCOPE-TIER.
 */
export const biRouteTierPermissions = (route: BiRouteKey): { pro?: string; manager?: string } => {
  const policy = BI_ROUTE_TIERS[route]
  const gated =
    Boolean(policy.pro || policy.body || policy.redact || policy.proFilters?.length) ||
    Object.keys(policy.proParams ?? {}).length > 0

  if (!gated) return {}

  return policy.manager === 'money' ? { pro: BI_PRO_PERMISSION, manager: BI_MANAGER_PERMISSION } : { pro: BI_PRO_PERMISSION }
}
